import Modal from '@/core/Modal';
import InputNumber from '../adscreate/InputNumber';
import { useContext, useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import api from '@/services/axios';
import ToastError from '../toast/ToastError';
import Button from '@/core/Button';
import { UserContext } from '@/context/createContext';
import ToastSuccess from '../toast/ToastSuccess';

function ModalInviteAgent({ isOpenRequest, setIsOpenRequest }) {
  const { realEstate } = useContext(UserContext);

  const [step, setStep] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneNumberError, setPhoneNumberError] = useState('');

  useEffect(() => {
    setStep(1);
    setPhoneNumber('');
    setPhoneNumberError('');
  }, [isOpenRequest]);

  const submitHandler = () => {
    if (!phoneNumberError) {
      ToastSuccess({content:"لینک دعوت با موفقیت ارسال شد"})
      setStep(2);
      setPhoneNumber('');
      setPhoneNumberError('');
    }
  };

  const { isPending, mutateAsync: mutate } = useMutation({
    mutationKey: ['post-notification'],
    mutationFn: async () => {
      await api.post('admin/notification', {
        realStateId: realEstate._id,
        phoneNumber: String(phoneNumber)[0] !== '0' ? '0' + String(phoneNumber) : String(phoneNumber),
      });
    },
    enabled: false,
    onSuccess: () => {
      setStep(2);
      setPhoneNumber('');
      setPhoneNumberError('');
    },
    onError: (error) => {
      ToastError({ content: error.response.data.message.split('(')[0] });
    },
  });
  return (
    <Modal
      className="gap-9 max-sm:gap-5 p-7"
      onOpenChange={setIsOpenRequest}
      width="530"
      height="480"
      title="دعوت مشاور جدید"
    >
      {step === 1 ? (
        <div className="flex flex-col items-center justify-center gap-2.5 max-sm:gap-7 text-center">
          <img src="/svg/request-agent.svg" className="w-44 h-44 max-sm:w-32 max-sm:h-32" alt="request-agent" />
          <p className="text-base max-sm:text-sm text-text-hard">
            برای دعوت مشاور جدید، شماره او را وارد کرده و روی «ارسال لینک دعوت» کلیک کنید. پس از تایید، پروفایل مشاور به
            لیست شما اضافه می‌شود.
          </p>
          <div className="grid grid-cols-[auto_134px] max-sm:grid-cols-1 gap-2.5 max-sm:gap-6 w-full items-end pb-5">
            <InputNumber
              name="phoneNumber"
              title="شماره تفلن"
              required={true}
              placeholder=""
              height="h-12"
              value={phoneNumber}
              errors={phoneNumberError}
              touched={true}
              handleChange={(e) => {
                if (!new RegExp(/^09\d{9}$/).test(e.target.value)) {
                  setPhoneNumberError('لطفا شماره تماس صحیح وارد نمایید !');
                } else {
                  setPhoneNumberError('');
                }
                setPhoneNumber(e.target.value);
              }}
            />
            <Button
              disabled={!!phoneNumberError || !phoneNumber}
              isLoading={isPending}
              height="h-12"
              width="w-full"
              variant="primary"
              handler={submitHandler}
              font="sm"
            >
              ارسال لینک دعوت
            </Button>
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center gap-10 text-center">
          <img src="/svg/success.svg" className="w-44 h-44 max-sm:w-32 max-sm:h-32" alt="success" />
          <p className="text-lg max-sm:text-sm text-text-hard">
            لینک دعوت شما با موفقیت برای مشاور جدید ارسال شد . منتظر تایید از طرف مشاور هستیم
          </p>
          <div className="flex items-center justify-center w-full">
            <Button
              height="h-12"
              width="w-40"
              variant="primary"
              handler={() => {
                setStep(1);
                setIsOpenRequest(false);
              }}
              font="sm"
            >
              متوجه شدم
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
}

export default ModalInviteAgent;
